import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import ListAltIcon from '@mui/icons-material/ListAlt';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { VocabularyTestScope } from 'pages/VocabularyTest/useVocabularyTestScope';

const pluralizeSubCategories = (n: number): string => {
  if (n === 1) return 'підкатегорія';
  if (n < 5) return 'підкатегорії';
  return 'підкатегорій';
};

const pluralizeCategories = (n: number): string => {
  if (n === 1) return 'категорія';
  if (n < 5) return 'категорії';
  return 'категорій';
};

interface VocabularyTestScopeSummaryProps {
  scope: VocabularyTestScope;
  open: boolean;
  onToggle: () => void;
}

const VocabularyTestScopeSummary: React.FC<VocabularyTestScopeSummaryProps> = ({
  scope,
  open,
  onToggle,
}) => {
  const wholeList = scope.soleFullWordSetType
    ? scope.wordSetOptions.find(
        (o) => o.wordSetType === scope.soleFullWordSetType,
      )
    : undefined;

  const label = !scope.selectedCount
    ? 'жодного слова — обери категорії нижче'
    : wholeList
    ? `усі слова з «${wholeList.label}»`
    : `${scope.selectedCount} ${pluralizeSubCategories(scope.selectedCount)} · ${scope.catCount} ${pluralizeCategories(scope.catCount)}`;

  return (
    <Stack
      direction={'row'}
      alignItems={'center'}
      spacing={1.25}
      sx={{
        bgcolor: 'background.default',
        border: '1px solid',
        borderColor: 'primary.tableBorder',
        borderRadius: 1,
        flexWrap: 'wrap',
        px: 2,
        py: 1.5,
        rowGap: 1,
      }}
    >
      {wholeList ? (
        <ListAltIcon sx={{ color: 'primary.main', fontSize: 20 }} />
      ) : (
        <FilterAltIcon sx={{ color: 'primary.main', fontSize: 20 }} />
      )}
      <Typography sx={{ color: 'text.secondary', fontSize: 14 }}>
        {'У тест увійдуть: '}
        <Box component={'b'} sx={{ color: 'text.primary', fontWeight: 700 }}>
          {label}
        </Box>
      </Typography>
      <Box sx={{ flex: 1 }} />
      {!scope.isDefault && (
        <Button variant={'text'} size={'small'} onClick={scope.reset}>
          {'Скинути'}
        </Button>
      )}
      <Button
        variant={'text'}
        size={'small'}
        endIcon={open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        onClick={onToggle}
      >
        {open ? 'Згорнути' : 'Змінити'}
      </Button>
    </Stack>
  );
};

export default VocabularyTestScopeSummary;
